<template
  ><div style="display:contents">
    <router-view v-if="$route.meta.emptyLayout" />
    <div id="app" v-bind:class="{'is-devmode': isDevMode}" v-if="!$route.meta.emptyLayout">
      <HeroInfoStandalone v-if="!$whitelabel.isStandalone && $whitelabel.heroHomeOnly" v-show="$route.path === '/'" />
      <HeroInfoStandalone v-if="!$whitelabel.isStandalone && !$whitelabel.heroHomeOnly" />

      <Navigation />

      <main role="main" class="section main-content">
        <transition name="fade" mode="out-in">
          <router-view v-bind:key="1" />
        </transition>
      </main>

      <ScrollToTop />

      <FooterProxy />

      <cookie-law storageName="acceptAllCookies">
        <div slot-scope="props">
          <div class="columns u-is-vcenter">
            <div class="column is-7 is-size-7-touch">
              {{ $t('consent.policy1') }}
              <a href="/datenschutz" class="has-text-white" :title="$t('consent.policy2')">{{ $t('consent.policy2') }}</a>
            </div>
            <div class="column is-5">
              <div class="buttons u-is-hend">
                <b-button
                  type="is-success"
                  class="is-size-7-touch"
                  @click="
                    props.accept()
                    allowCookies()
                  "
                  >{{ $t('consent.allow_cookies') }}</b-button
                >
                <b-button
                  type="is-light"
                  class="is-size-7-touch"
                  @click="
                    props.decline()
                    declineCookies()
                  "
                  >{{ $t('consent.just_necessary_cookies') }}</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </cookie-law>

      <Drawer :direction="'right'" :exist="true" ref="CartDrawer"><CartDisplay /></Drawer>

      <b-modal :active="showLoginWindow" scroll="keep">
        <LoginWindow />
      </b-modal>

      <b-loading :is-full-page="true" :active.sync="displayLoading" :can-cancel="false">
        <!-- <b-icon pack="fas" icon="circle-notch" size="is-large" custom-class="fa-spin"></b-icon> -->
      </b-loading>
      <Awin v-if="$whitelabel.awinId"></Awin>
      <Adcell v-if="$whitelabel.adcell"></Adcell>

      <script type="application/ld+json" v-html="snippedData"></script>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import HeroInfoStandalone from '@/components/HeroInfoStandalone'
import CookieLaw from 'vue-cookie-law'
import {mapGetters} from 'vuex'
import {bootstrap} from 'vue-gtag'
// import ThirdPartyUtils from '@/common/thirdparty-utils'

//lazyload components
const FooterProxy = () => import(/* webpackChunkName: "footer" */ '@/components/Footer')
const ScrollToTop = () => import(/* webpackChunkName: "scrolltotop" */ '@/components/ScrollToTop')
const CartDisplay = () => import(/* webpackChunkName: "cartdisplay" */ '@/components/CartDisplay')
const Drawer = () => import(/* webpackChunkName: "drawer" */ './components/Drawer.vue')
const LoginWindow = () => import(/* webpackChunkName: "loginwindow" */ '@/components/Auth/LoginWindow')
const Awin = () => import(/* webpackChunkName: "awin" */ '@/components/ThirdParty/Awin')
const Adcell = () => import(/* webpackChunkName: "adcell" */ '@/components/ThirdParty/Adcell')

export default {
  name: 'App',
  components: {
    CartDisplay,
    Navigation,
    FooterProxy,
    ScrollToTop,
    HeroInfoStandalone,
    CookieLaw,
    LoginWindow,
    Drawer,
    Awin,
    Adcell,
  },
  computed: {
    ...mapGetters({
      displayLoading: 'disableSite',
      drawer: 'drawer',
      isAnalyticsDeactivated: 'isAnalyticsDeactivated',
      showLoginWindow: 'showLoginWindow',
    }),
    snippedData() {
      return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url: window.location.origin,
        logo: this.$whitelabel.logoHeader,
      }
    },
  },
  data() {
    return {
      drawerWidth: 750,
      refreshing: false,
      isDevMode: process.env.NODE_ENV == 'development',
      cookiesEnabled: localStorage.acceptAllCookies === 'true',
    }
  },
  mounted() {
    if (this.$whitelabel.analyticsType === 'gtag' && localStorage.acceptAllCookies === 'true') {
      this.allowCookies() // "TypeError: Cannot add property enabled, object is not extensible ?
    }

    //load thirdparty pixels depending on shop
    //ThirdPartyUtils.loadGlobal(this.$whitelabel.short)
  },
  beforeCreate() {
    this.$store.dispatch('loadMenuEntires')
  },
  created() {
    document.addEventListener('swUpdated', this.swUpdated, {once: true})
  },
  methods: {
    swUpdated(e) {
      const reg = e.detail
      if (!reg || !reg.waiting) {
        return
      }
      reg.waiting.postMessage('skipWaiting')
      this.$buefy.toast.open({
        message: this.$t('notices.update-required'),
        type: 'is-success',
      })
      window.location.reload()
    },
    handleSlideEnd(visible) {
      let mainContent = document.querySelector('.content-wrap')

      if (visible) {
        mainContent.classList.add('is-clipped')
      } else {
        mainContent.classList.remove('is-clipped')
      }
    },
    handleMaskClick() {
      this.$store.dispatch('hideDrawer')
    },
    declineCookies() {
      let analyticstype = this.$whitelabel.analyticsType

      if (analyticstype == 'gtag' || analyticstype == 'both') {
        bootstrap().then(() => {
          // all done!
          this.$gtag.optOut()
        })
      }

      if (analyticstype == 'ua' || analyticstype == 'both') {
        this.$ga.disable()
      }

      if (this.$whitelabel.tagManager) {
        this.$gtm.enable(false) // google tag manager
      }

      this.$store.dispatch('deactivateAnalytics')
    },
    allowCookies() {
      let analyticstype = this.$whitelabel.analyticsType

      if (analyticstype == 'gtag' || analyticstype == 'both') {
        bootstrap().then(() => {
          // all done!
          this.$gtag.optIn()
        })
      }

      if (analyticstype == 'ua' || analyticstype == 'both') {
        this.$ga.enable() //google analytics
      }

      if (this.$whitelabel.fbPixelEnabled) {
        this.analytics.fbq.init(this.$whitelabel.fbPixelId) //facebook pixel
        this.analytics.fbq.event('PageView') //facebook pixel pageview
      }
      if (this.$whitelabel.tagManager) {
        this.$gtm.enable(true) // google tag manager
      }

      this.$store.dispatch('activateAnalytics')
    },
  },
  metaInfo() {
    const storeName = this.$whitelabel.storeName

    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title: `${storeName}`,
      titleTemplate: `%s | ${storeName}`,
      link: [
        {rel: 'preconnect', href: '//unpkg.com', crossorigin: 'anonymous'},
        {
          rel: 'preconnect',
          href: '//www.google-analytics.com',
          crossorigin: 'anonymous',
        },
        {
          rel: 'preconnect',
          href: '//use.fontawesome.com',
          crossorigin: 'anonymous',
        },
        {
          rel: 'preconnect',
          href: '//assets.urlaubsgutschein.kaufen',
          crossorigin: 'anonymous',
        },
        {
          rel: 'preload',
          href: 'https://use.fontawesome.com/releases/v5.10.0/css/all.css',
          crossorigin: 'anonymous',
          as: 'style',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.main-wrapper {
  padding-top: 3.25em;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
}

.main-content {
  flex: 1;
  // padding-left: 0.4rem !important;
  // padding-right: 0.4rem !important;
}

.content-wrap {
  overflow: auto !important;
}

@media screen and (max-width: 768px) {
  .drawer-wrap {
    width: 100% !important;
  }

  .drawer-layout {
    overflow-y: scroll !important;
  }

  .main-content {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

@media print {
  .main-content {
    padding-top: 0 !important;
  }
}
</style>
